import { z } from "zod";
// ─────────────────────────────────────────────────────────────────────────────
// EPIC Avis clients (REVIEWS_ENABLED) — schémas partagés client/serveur.
//
// GATE (AGENTS.md §10) : les routes refusent (503) tant que le flag est OFF ;
// ces schémas ne font que décrire la frontière.
//
// Étoiles : entier 1..5, toujours. La note générale est OBLIGATOIRE ; les
// étoiles par prestation/produit sont optionnelles (formulaire du pro,
// askItemRatings). L'avis est PUBLIÉ dès le dépôt (« dès le premier avis
// laissé il s'affiche ») — la dépublication est un acte admin.
// ─────────────────────────────────────────────────────────────────────────────
export const ReviewStarsSchema = z.number().int().min(1).max(5);
/** Réglages du formulaire d'avis, côté pro (PUT /v1/pro/reviews/settings). */
export const ReviewSettingsInputSchema = z.object({
    /** Email automatique après une prestation clôturée COMPLETED. */
    autoSendBooking: z.boolean(),
    /** Email automatique après une commande marquée DELIVERED. */
    autoSendOrder: z.boolean(),
    /** Délai avant envoi, en heures (1 h à 7 jours). */
    sendDelayHours: z.number().int().min(1).max(168),
    /** Message d'introduction du formulaire (null = texte par défaut). */
    introText: z.string().trim().max(500).nullable(),
    /** Le formulaire propose un commentaire libre. */
    askComment: z.boolean(),
    /** Étoiles PAR prestation/produit, en plus de la note générale. */
    askItemRatings: z.boolean(),
});
/** Note par prestation/produit d'un avis (exactement une des deux cibles). */
export const ReviewItemInputSchema = z
    .object({
    serviceId: z.string().uuid().optional(),
    productId: z.string().uuid().optional(),
    stars: ReviewStarsSchema,
})
    .refine((i) => (i.serviceId ? 1 : 0) + (i.productId ? 1 : 0) === 1, {
    message: "exactly one of serviceId/productId is required",
});
/**
 * Dépôt d'un avis via le lien email (POST /v1/public/reviews/:token).
 * `authorName` : le déposant peut corriger la signature proposée (jamais
 * l'email — il n'apparaît nulle part publiquement).
 */
export const SubmitReviewInputSchema = z.object({
    stars: ReviewStarsSchema,
    comment: z.string().trim().max(1000).optional(),
    authorName: z.string().trim().min(1).max(80).optional(),
    items: z.array(ReviewItemInputSchema).max(20).optional(),
});
/** Demande d'aide d'un pro à l'équipe (POST /v1/pro/help-requests). */
export const ProHelpRequestInputSchema = z.object({
    body: z.string().trim().min(5).max(2000),
});
//# sourceMappingURL=reviews.js.map